module.exports = __webpack_public_path__ + "img/Mask2.fad4832.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/AISmart/Mask2.png
// module id = nIpE
// module chunks = 149